import { redirect } from "@tanstack/react-router";
import { supabase } from "./supabase";

/**
 * Route guard to require authentication.
 * Throws a redirect to /login if the user is not authenticated.
 */
export async function requireAuth() {
  const {
    data: { user },
  } = await supabase.auth.getUser();

  if (!user) {
    throw redirect({
      to: "/login",
      search: { redirect: window.location.pathname },
    });
  }

  return { user };
}
